export const updateProfile = (id, params, successCallback) => {
  fetch(`/api/v1/profiles/${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PATCH',
    body: JSON.stringify({
      profile: params,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const getMentorMatchFromProfile = (successCallback) => {
  fetch(`/api/v1/profiles/mentor_match`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        console.error(`Error: HTTP status ${response.status}`);
        return null;
      }
      return response.json();
    })
    .then((data) => {
      if (data !== null) {
        successCallback(data);
      } else {
        successCallback(null);
      }
    })
    .catch((error) => {
      console.error('Error getting mentor match from profile:', error);
    });
};
